import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { RestaurantMap } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useRestaurantMapUpdate = () => {
  const branchId = useBranchId();
  const { t } = useTranslation("");
  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.update"));
    },
    mutationFn: ({ item_id, ...restaurant }: RestaurantMap) =>
      put2(
        `/internal/secure/pos/v1/restaurant/map/${branchId}/${item_id}`,
        restaurant
      ),
  });
  return mutation;
};

export default useRestaurantMapUpdate;
